import type { AssetDataType } from '@repo/types/asset';
import { isOrder } from '@repo/types/order';

import { EmailShareOption } from '@/components/share/share-options/email-share-option';
import { PrintShareOption } from '@/components/share/share-options/print-share-option';
import { SmsShareOption } from '@/components/share/share-options/sms-share-option';

import { ShareLocaleSelect } from './share-locale-select';
import type { SupportedLocaleOption } from './share-locale-select';

import styles from './styles.module.scss';

interface Props {
    data: AssetDataType;
    email: ShareOption;
    sms: ShareOption;
    printer: ShareOption;
    locale?: string | undefined;
    setLocale: (locale?: string) => void;
    setEmail: (email: ShareOption) => void;
    setSms: (sms: ShareOption) => void;
    setPrinter: (printer: ShareOption) => void;
    shouldValidate: boolean;
    supportedLocales: SupportedLocaleOption[];
    divider?: boolean | undefined;
}

export interface ShareOption {
    type: 'email' | 'sms' | 'print';
    value: string | undefined;
    printerName?: string | undefined;
    printServer?: string | undefined;
    noOfCopies?: number;
    printTermsAndConditions?: boolean;
    checked: boolean;
}

export const ShareOptions = ({
    data,
    email,
    sms,
    printer,
    locale,
    setLocale,
    setEmail,
    setSms,
    setPrinter,
    supportedLocales,
    shouldValidate,
    divider,
}: Props) => {
    return (
        <div className={styles.form} data-testid="share-options">
            <EmailShareOption
                email={email}
                setEmail={setEmail}
                shouldValidate={shouldValidate}
                assetType={data.assetType}
            />

            <SmsShareOption
                sms={sms}
                setSms={setSms}
                shouldValidate={shouldValidate}
                assetType={data.assetType}
                orderType={isOrder(data) ? data.assetDetails.orderType : undefined}
            />
            <PrintShareOption
                shouldValidate={shouldValidate}
                data={data}
                assetType={data.assetType}
                printer={printer}
                setPrinter={setPrinter}
            />
            <ShareLocaleSelect
                supportedLocales={supportedLocales}
                setLocale={setLocale}
                shouldValidate={shouldValidate}
                locale={locale}
                divider={divider}
                data={data}
            />
        </div>
    );
};
